module.exports = __webpack_public_path__ + "img/AT0000002790218.ca2ed176.png";